<div class="modal-header">
  <div>
    <h4 class="modal-title" id="qa-template-variable-title">{{_(title)}}</h4>
    <p class="qa-variable-intro">{{_(hint)}}</p>
  </div>
  <button type="button" class="close" [attr.aria-label]="_(KEYS.EDITOR.CLOSE)" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body qa-variable-body">
  <label class="qa-variable-search">
    <i class="fa fa-search" aria-hidden="true"></i>
    <input type="search" class="form-control" ngbAutofocus [(ngModel)]="query" (ngModelChange)="filter()"
           [placeholder]="_(KEYS.EDITOR.TEXT_VARIABLE_SEARCH)" [attr.aria-label]="_(KEYS.EDITOR.TEXT_VARIABLE_SEARCH)">
  </label>
  <div class="qa-variable-filters" role="group" [attr.aria-label]="_(KEYS.EDITOR.TEXT_VARIABLE_CATEGORIES)">
    <button type="button" [class.active]="!activeGroup" [attr.aria-pressed]="!activeGroup" (click)="selectGroup('')">
      {{_(allLabel)}} <span>{{variables.length}}</span>
    </button>
    <ng-container *ngFor="let group of groups">
      <button *ngIf="counts[group.id]" type="button" [class.active]="activeGroup === group.id"
              [attr.aria-pressed]="activeGroup === group.id" (click)="selectGroup(group.id)">
        {{_(group.label)}} <span>{{counts[group.id]}}</span>
      </button>
    </ng-container>
  </div>
  <div class="qa-variable-results">
    <section *ngFor="let group of visibleGroups">
      <h5><i class="fa" [ngClass]="group.icon" aria-hidden="true"></i>{{_(group.label)}}</h5>
      <section *ngFor="let question of group.questions" class="qa-picker-question">
        <h6 class="qa-picker-question-heading">
          <button type="button" class="qa-picker-question-toggle" (click)="toggleQuestion(group.id + ':' + question.id)"
                  [attr.aria-expanded]="searching || !collapsedQuestions.has(group.id + ':' + question.id)"
                  [attr.aria-controls]="'qa-picker-answers-' + group.id + '-' + question.id" [attr.aria-disabled]="searching || null">
            <i class="fa" [ngClass]="searching || !collapsedQuestions.has(group.id + ':' + question.id) ? 'fa-angle-down' : 'fa-angle-right'"
               aria-hidden="true"></i>
            <span>{{question.title}}</span><span class="qa-picker-question-count">{{question.variables.length}}</span>
          </button>
        </h6>
        <div [id]="'qa-picker-answers-' + group.id + '-' + question.id" [hidden]="!searching && collapsedQuestions.has(group.id + ':' + question.id)"
             class="qa-picker-answers">
          <button *ngFor="let variable of question.variables" type="button" class="qa-variable-option qa-answer-option"
                  [class.qa-variable-selected]="variable.path === selected" [attr.aria-current]="variable.path === selected || null"
                  (click)="activeModal.close(variable)" [attr.title]="variable.label + '\n' + variable.template"
                  [attr.aria-label]="variable.label">
            <span class="qa-variable-token" aria-hidden="true"><i *ngIf="variable.group === 'answers'; else fieldBraces"
              class="fa fa-check-square-o"></i><ng-template #fieldBraces>&#123;&#125;</ng-template></span>
            <span class="qa-variable-name qa-answer-name">
              <span *ngIf="variable.questionContext.ancestors.length" class="qa-answer-ancestors"
                    aria-hidden="true">{{variable.questionContext.ancestors.join(' › ')}}</span>
              <strong>{{variable.questionContext.label}}</strong>
              <code *ngIf="showPaths || variable.group !== 'answers'">{{variable.template}}</code>
            </span>
            <span *ngIf="variable.path === selected" class="qa-variable-current">{{_(KEYS.EDITOR.TEXT_VARIABLE_CURRENT)}}</span>
            <i *ngIf="variable.path !== selected" class="fa fa-plus" aria-hidden="true"></i>
          </button>
        </div>
      </section>
      <button *ngFor="let variable of group.variables" type="button" class="qa-variable-option"
              [class.qa-variable-selected]="variable.path === selected" [attr.aria-current]="variable.path === selected || null"
              (click)="activeModal.close(variable)" [attr.title]="variable.label + '\n' + variable.template">
        <span class="qa-variable-token" [class.qa-variable-token-formula]="variable.group === 'formula'" aria-hidden="true"><i *ngIf="variable.group === 'answers'; else braces" class="fa fa-check-square-o"></i><ng-template #braces><i *ngIf="variable.group === 'formula'; else plainBraces" class="fa fa-calculator"></i><ng-template #plainBraces>&#123;&#125;</ng-template></ng-template></span>
        <span class="qa-variable-name" [class.qa-variable-name-compact]="!showPaths"><strong>{{variable.label}}</strong><code *ngIf="showPaths">{{variable.template}}</code></span>
        <span *ngIf="variable.path === selected" class="qa-variable-current">{{_(KEYS.EDITOR.TEXT_VARIABLE_CURRENT)}}</span>
        <i *ngIf="variable.path !== selected" class="fa fa-plus" aria-hidden="true"></i>
      </button>
    </section>
    <div class="qa-variable-empty" *ngIf="!resultCount" role="status">
      <i class="fa fa-search" aria-hidden="true"></i>
      <strong>{{_(KEYS.EDITOR.TEXT_VARIABLE_EMPTY)}}</strong>
      <span>{{_(KEYS.EDITOR.TEXT_VARIABLE_EMPTY_HINT)}}</span>
    </div>
  </div>
</div>
<div class="modal-footer qa-variable-footer">
  <span><i class="fa fa-info-circle" aria-hidden="true"></i> {{_(footer)}}</span>
  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">{{_(KEYS.EDITOR.TEXT_VARIABLE_CANCEL)}}</button>
</div>
